export enum AttachmentTypes {
  ServiceCall,
  Integration,
}

export function getAttachmentTypeString(type: AttachmentTypes) {
  switch (type) {
    case AttachmentTypes.ServiceCall:
      return "servicecall";
    case AttachmentTypes.Integration:
      return "integration";
  }
}
